import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";

import './Testimonials.css';
import imgr from "./Images/IP1.jpg";
const Testimonials = () => {

    const location = useLocation();

    useEffect(() => {
        if (location.hash === "#testimonials") {
            const section = document.getElementById("testimonials");
            section?.scrollIntoView({ behavior: "smooth" });
        }
    }, [location]);
    // Testimonials data
    const testimonials = [
       
        {
            id: 1,
            name: "Prakash Arora",
            role: "Director & M.D – Cosmos",
            comment: "BG RealEstate360 provided professional and transparent support in understanding our industrial property needs. Their market knowledge and timely coordination ensured a smooth and reliable experience.",
            rating: 5,
            image: imgr,
        },
        {
            id: 2,
            name: " Mahendra Yadav",
            role: "M.D – Nisha Engineering",
            comment: "BG RealEstate360 clearly understood our requirements and guided us to the right industrial property. Their professional approach, prompt response, and reliable service are truly appreciated.",
            rating: 5,
            image: imgr,
        },
        {
            id: 3,
            name: "Sunil Singh",
            role: "Sumit Industries Limited",
            comment: "BG RealEstate360 managed our real estate requirement with complete professionalism. From property options to finalization, the entire process was smooth and efficiently handled.",
            rating: 5,
            image: imgr,
        },
        {
            id: 4,
            name: "Umesh Patel",
            role: "Kendal Group",
            comment: "We are satisfied with the services of BG RealEstate360. Their clear communication, honest guidance, and strong local market understanding helped us make the right decision.",
            rating: 5,
            image: imgr,
        },
        {
            id: 5,
            name: "Basant Chaudhary",
            role: "Sun Siddhi Fashion",
            comment: "BG RealEstate360 supported us professionally in finding a suitable property. The process was transparent, well-organized, and managed efficiently from start to finish.",
            rating: 5,
            image: imgr,
        }
        
    ];

    const [activeTestimonial, setActiveTestimonial] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    // Auto-rotate testimonials
    useEffect(() => {
        if (isPaused) return;

        const interval = setInterval(() => {
            setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [isPaused, testimonials.length]);

    // Handle testimonial navigation
    const handlePrev = () => {
        setActiveTestimonial(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
    };

    const handleNext = () => {
        setActiveTestimonial(prev => (prev + 1) % testimonials.length);
    };

    // Handle dot navigation
    const handleDotClick = (index) => {
        setActiveTestimonial(index);
    };

    return (
        <section className="testimonials-section" id="testimonials">
            <div className="testimonials-container">
                {/* Section Header */}
                <div className="testimonials-header">
                    <div className="section-badge">
                        <span className="badge-text">Testimonials</span>
                        <div className="badge-line"></div>
                    </div>
                    <h2 className="testimonials-title">Trusted by <span className="highlight">50+</span> Clients</h2>
                    <p className="testimonials-subtitle">Don't just take our word for it. Here's what our clients have to say about their experience.</p>
                </div>

                {/* Main Testimonial Display (Desktop) */}
                <div className="testimonials-main">
                    <div className="testimonial-featured">
                        <div className="testimonial-quote-icon">"</div>
                        <p className="testimonial-featured-comment">"{testimonials[activeTestimonial].comment}"</p>
                        <div className="testimonial-featured-author">
                            <img
                                src={testimonials[activeTestimonial].image}
                                alt={testimonials[activeTestimonial].name}
                                className="author-featured-image"
                            />
                            <div className="author-featured-info">
                                <h4 className="author-featured-name">{testimonials[activeTestimonial].name}</h4>
                                <p className="author-featured-role">{testimonials[activeTestimonial].role}</p>
                                <div className="featured-rating">
                                    {[...Array(testimonials[activeTestimonial].rating)].map((_, i) => (
                                        <span key={i} className="star-icon">★</span>
                                    ))}
                                    <span className="rating-text">{testimonials[activeTestimonial].rating}.0</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Navigation Controls */}
                    <div className="testimonial-controls">
                        <button
                            className="control-button prev-button"
                            onClick={handlePrev}
                            aria-label="Previous testimonial"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>

                        <div className="testimonial-dots">
                            {testimonials.map((_, index) => (
                                <button
                                    key={index}
                                    className={`dot ${index === activeTestimonial ? 'active' : ''}`}
                                    onClick={() => handleDotClick(index)}
                                    onMouseEnter={() => setIsPaused(true)}
                                    onMouseLeave={() => setIsPaused(false)}
                                    aria-label={`Go to testimonial ${index + 1}`}
                                />
                            ))}
                        </div>

                        <button
                            className="control-button next-button"
                            onClick={handleNext}
                            aria-label="Next testimonial"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Testimonial Grid (Mobile & Additional) */}
                <div className="testimonials-grid">
                    {testimonials.slice(0, 4).map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className="testimonial-card"
                            onMouseEnter={() => setIsPaused(true)}
                            onMouseLeave={() => setIsPaused(false)}
                        >
                            <div className="testimonial-card-header">
                                <div className="card-rating">
                                    {[...Array(testimonial.rating)].map((_, i) => (
                                        <span key={i} className="star-icon">★</span>
                                    ))}
                                    <span className="card-rating-count">{testimonial.rating}.0</span>
                                </div>
                                <div className="card-quote-icon">"</div>
                            </div>

                            <p className="testimonial-card-comment">"{testimonial.comment}"</p>

                            <div className="testimonial-card-author">
                                <img
                                    src={testimonial.image}
                                    alt={testimonial.name}
                                    className="author-card-image"
                                />
                                <div className="author-card-info">
                                    <h4 className="author-card-name">{testimonial.name}</h4>
                                    <p className="author-card-role">{testimonial.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA Section */}
               
            </div>
        </section>
    );
};

export default Testimonials;